import { Injectable } from "@angular/core";
import { StaffSurplusRefundsService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { SurplusRefundsPort } from "../../../app/ports/treasury/surplus-refunds.port";
import { SurplusRefund, SurplusRefundRequest, SurplusRefundReviewRequest } from "../../../domain/models/treasury/surplus-refund.model";
import { mapSurplusRefund, mapSurplusRefundRequest, mapSurplusRefundReviewRequest } from "../../mappers/treasury/surplus-refund.mapper";

@Injectable({ providedIn: "root" })
export class SurplusRefundsPortAdapter implements SurplusRefundsPort {
  constructor(private readonly api: StaffSurplusRefundsService) {}

  create(request: SurplusRefundRequest): Observable<SurplusRefund> {
    return this.api.create(mapSurplusRefundRequest(request)).pipe(map(({ data }) => mapSurplusRefund(data)));
  }

  listByExpenseReport(idExpenseReport: number): Observable<readonly SurplusRefund[]> {
    return this.api.listByExpenseReport(idExpenseReport).pipe(map(({ data }) => data.map(mapSurplusRefund)));
  }

  get(id: number): Observable<SurplusRefund> {
    return this.api.get(id).pipe(map(({ data }) => mapSurplusRefund(data)));
  }

  review(id: number, request: SurplusRefundReviewRequest): Observable<SurplusRefund> {
    return this.api.review(id, mapSurplusRefundReviewRequest(request)).pipe(map(({ data }) => mapSurplusRefund(data)));
  }
}
